import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import AgentDetailHeader from '../components/AgentDetailHeader';
import { AgentDetailData } from '../types/index';
import GitHubSection from '../components/GithubSection';
import BulletPointsSection from '../components/BulletPointsSection';

const AgentDetailPage: React.FC = () => {
    const location = useLocation();
    const agent = location.state as AgentDetailData;
    console.log(agent)

    if (!agent) {
        return (
            <div className="min-h-screen bg-black text-white p-8">
                <Navbar />
                <div className="text-red-500">Agent not found</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-black text-white">
                   {/* Background gradient */}
                    {/* <div className="absolute inset-0 bg-gradient-to-b from-purple-900/20 to-[#0a0a0a]" /> */}
                    <div className="absolute top-0 left-0 right-0 h-full bg-gradient-to-b from-purple-900/20 to-[#000000] z-0" />
            <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-8">
                <Navbar />
                <AgentDetailHeader agent={agent} />
                
                {/* About Section */}
                <div className="border-t border-gray-800 pt-4 sm:pt-6 z-10 relative">
                    <h2 className="text-lg font-semibold mb-3 sm:mb-4">About</h2>
                    <p className="text-gray-400 text-sm leading-relaxed max-w-3xl">
                        {agent?.description}
                    </p>
                </div>

                {/* Bullet Points Section */}
                {
                agent.bullet_points && <BulletPointsSection bulletPoints={agent.bullet_points} />
                
                }

                

                {/* GitHub Section - Only pass agentId if project is open source */}
                {agent.openSource && agent.github_url && (
                    <GitHubSection agentId={agent.id.toString()} />
                )}
            </div>
        </div>
    );
};

export default AgentDetailPage; 